<div class="booking-details-container">
  <!-- Header -->
  <div class="header">
    <button class="back-button" (click)="goBackToSearch()">
      <mat-icon>arrow_back</mat-icon>

    </button>
    <h1>Booking Details</h1>
  </div>

  <!-- Mobile Cost Breakdown Header (hidden by default) -->
  <div class="mobile-cost-breakdown-header">
    <button class="back-button" (click)="goBackToUserDetails()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>Cost Breakdown</h1>
  </div>
 
  <!-- Main Content -->
  <div class="main-content">
    <div class="car-details-section">
      <div class="car-info">
        <div class="car-image position-relative">
          <img [src]="bookingData.vehicleImage" [alt]="bookingData.vehicleName">
          <h3 class="position-absolute top-0 start-0 text-white car-name">{{ bookingData.vehicleName }}</h3>
        </div>
      </div>

      <div class="booking-details-list">
        <div class="detail-item">
          <img src="assets/VehicleIcon.svg" alt="car">
          <span> Package: {{ bookingData.packageName }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/Serving_CityIcon.svg" alt="car">
          <span>Serving City: {{ bookingData.servingCity }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/numberof_Bag.svg" alt="car">
          <span>Number of Bag: {{ bookingData.noOfBags }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/numberof_days.svg" alt="car">
          <span>Number of Days: {{ bookingData.noOfDays }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/sitting_Capacity.svg" alt="car">
          <span>Seating Capacity: {{ bookingData.seatingCapacity }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/basicHrs.svg" alt="car">
          <span>Basic Hrs: {{ bookingData.basicHrs }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/dateIcon.svg" alt="car">
          <span>Date: {{ bookingData.date }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/basic_Km.svg" alt="car">
          <span>Basic Kms: {{ bookingData.basicKM }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/time_Icon.svg" alt="car">
          <span>Time: {{ bookingData.time }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/parking_Icon.svg" alt="car">
          <span>Parking Charges: {{ bookingData.parkingIncExc }}</span>
        </div>
        <div class="detail-item">
          <img src="assets/toll_Icon.svg" alt="car">
          <span>Toll Charges: {{ bookingData.tollIncExc }}</span>
        </div>
      </div>
    </div>

    <div class="user-details-section">
      <div class="section-header">
        <h3>User Details</h3>
        <div class="gst-toggle">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="showGstDetails">
            <span class="slider"></span>
          </label>
          <span>Add GST Details</span>
        </div>
      </div>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control" [(ngModel)]="userDetails.name" placeholder="Enter your name"
               [class.error-border]="showNameError" (input)="onFieldChange('name')" (keypress)="onCharacterOnlyInput($event)" maxlength="60">
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Mobile Number</label>
          <input type="tel" class="form-control" [(ngModel)]="userDetails.mobileNumber"
            placeholder="Enter mobile number" [class.error-border]="showMobileError" (input)="onFieldChange('mobileNumber')">
        </div>
        <div class="form-group">
          <label>Passengers Count</label>
          <input type="text" pattern="[1-7]" class="form-control" [(ngModel)]="userDetails.passengersCount" placeholder="Enter count"
                 [class.error-border]="showPassengerCountError" (input)="validatePassengerCount($event)" (change)="onFieldChange('passengersCount')">
        </div>
      </div>

      <div class="form-group">
        <label>Email ID</label>
        <input type="email" class="form-control" [(ngModel)]="userDetails.emailId" placeholder="Enter email address">
      </div>

      <div class="form-group">
        <label>Pickup Address</label>
        <div class="input-with-icon">
          <input type="text" class="form-control" [(ngModel)]="userDetails.Address"
            placeholder="Enter pickup address" [class.error-border]="showPickupAddressError" (input)="onFieldChange('Address')">
          <img src="assets/ep_location.svg" alt="map-marker">
        </div>
      </div>

      <div class="form-group">
        <label>Drop Address</label>
        <div class="input-with-icon">
          <input type="text" class="form-control" [(ngModel)]="userDetails.dropAddress"
            placeholder="Enter drop address" [class.error-border]="showDropAddressError" (input)="onFieldChange('dropAddress')">
          <img src="assets/ep_location.svg" alt="map-marker">
        </div>
      </div>

      <div class="form-row" *ngIf="showGstDetails">
        <div class="form-group">
          <label>GST Number</label>
          <input type="text" 
                 class="form-control" 
                 [(ngModel)]="userDetails.gstNumber" 
                 placeholder="GST No." 
                 [class.error-border]="showGstNumberError"
                 (input)="onFieldChange('gstNumber')"
                 maxlength="15"
                 style="text-transform: uppercase;">
          <small class="text-muted" *ngIf="showGstDetails">Format: 22AAAAA0000A1Z5 (15 characters)</small>
        </div>
        <div class="form-group">
          <label>Billing Name</label>
          <input type="text" class="form-control" [(ngModel)]="userDetails.billingName"
            placeholder="Enter billing name">
        </div>
      </div>

      <div class="form-group" *ngIf="showGstDetails">
        <label>Pickup Address</label>
        <div class="input-with-icon">
          <input type="text" class="form-control" [(ngModel)]="userDetails.billingPickupAddress"
            placeholder="Enter pickup address">
          <img src="assets/ep_location.svg" alt="map-marker">
        </div>
      </div>
    </div>

    <!-- Mobile Navigation Buttons -->
    <div class="mobile-navigation-buttons">
      <button class="btn-back" (click)="goBackToSearch()">Back</button>
      <button class="btn-continue" (click)="showCostBreakdownOnMobile()">Continue</button>
    </div>

    <!-- Right Section: Cost Breakdown -->
    <div class="cost-breakdown-section">
      <h3>Cost Breakdown</h3>
      <div class="cost-breakdown">
        <div class="cost-item">
          <span>Basic Amount</span>
          <span>₹ {{ bookingData.packageAmount | number:'1.2-2' }}</span>
        </div>
        <div class="cost-item">
          <span>Tax Amount {{bookingData.cgst + bookingData.sgst}}%</span>
          <span>₹ {{ (bookingData.cgstAmount + bookingData.sgstAmount) | number:'1.2-2' }}</span>
        </div>
        <div class="cost-item total">
          <span>Total Amount</span>
          <span>₹ {{ bookingData.totalFare | number:'1.2-2' }}</span>
        </div>
        <div class="cost-item">
          <span>Extra per Km</span>
          <span>₹ {{ bookingData.extraPerKm | number:'1.2-2' }}</span>
        </div>
        <div class="cost-item">
          <span>Extra per Hr</span>
          <span>₹ {{ bookingData.extraHrs | number:'1.2-2' }}</span>
        </div>
      </div>

      <div class="additional-details">
        <a class="show-details-link" (click)="toggleAdditionalDetails($event)">
          <mat-icon>{{ showAdditionalDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{ showAdditionalDetails ? 'Hide' : 'Show' }} additional pricing details
        </a>
        <div class="additional-pricing-content" *ngIf="showAdditionalDetails && bookingData.b2CTermsAndConditions">
          <!-- Dynamic content from API -->
          <div class="pricing-item">
            <div [innerHTML]="formatAdditionalContent(bookingData.b2CTermsAndConditions)"></div>
          </div>
        </div>
      </div>

      <div class="payment-options" *ngIf="bookingData.isShowPerAmt">
        <button class="payment-btn pay-50" 
                [class.active]="selectedPaymentOption === '50'"
                (click)="onPay50Percent()">
          <span>{{bookingData.isPerBookingAmt}}%</span>
          <span class="amount">₹ {{ percentageAmount | number:'1.0-0' }}</span>
        </button>
        <button class="payment-btn pay-100" 
                [class.active]="selectedPaymentOption === '100'"
                (click)="onPay100Percent()">
          <span>Pay 100%</span>
          <span class="amount">₹ {{ fullAmount | number:'1.0-0' }}</span>
        </button>
      </div>

      
     <div class="d-grid gap-2 mb-4 w-100" *ngIf="!bookingData.isShowPerAmt">
        <button type="button"
                class="payment-btn pay-50 btn w-100 text-white border-0 py-3 lh-base fs-5 d-flex flex-row align-items-center justify-content-center gap-2 rounded-2"
                style="background-color: #91BF38;"
                [class.active]="selectedPaymentOption === '50'">
                <span class="text-white">Pay 100%</span>
                <span class="amount mt-0 text-white">₹ {{ fullAmount | number:'1.0-0' }}</span>
        </button>
     </div>
      

      <div class="terms-checkbox">
        <label class="checkbox-container">
          <input type="checkbox"  [(ngModel)]="termsAccepted">
          <span class="checkmark" [class.error-border]="showcheckboxError"></span>
          <span class="terms-text">
            I have read the <a (click)="navigateToTerms()" class="policy-link">Terms & Conditions</a> and <a (click)="navigateToCancellation()" class="policy-link">Cancellation Policy</a> and <a
              (click)="navigateToPrivacy()" class="policy-link">Privacy Policy</a> I agree to all the terms therein.
          </span>
        </label>
      </div>

      <div class="action-buttons">
        <button class="btn1 btn-outline" (click)="onPayLater()">
          Pay Later
        </button>
        <button class="btn1 btn-primary1" (click)="onPayNow()">Pay Now</button>
      </div>
    </div>
  </div>
  
  <!-- Full screen loading overlay -->
  <div class="loading-overlay" *ngIf="isBookingLoading">
    <mat-progress-spinner mode="indeterminate" diameter="60" strokeWidth="4"></mat-progress-spinner>
  </div>
</div>